import React from 'react';
import { Link } from 'react-router-dom';
import LoginForm from 'components/authentication/LoginForm';
import AuthCardLayout from 'layouts/AuthCardLayout';
import paths from 'routes/paths';

const Login = () => {
  return (
    <AuthCardLayout
      leftSideContent={
        <p className="text-white">
          ¿No tienes una cuenta?
          <br />
          <Link
            className="text-white text-decoration-underline"
            to={paths.cardRegister}
          >
            ¡Regístrate ahora!
          </Link>
        </p>
      }
    >
      <h3>Iniciar sesión</h3>
      <LoginForm layout="card" hasLabel />
    </AuthCardLayout>
  );
};

export default Login;
